import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryOptionsConfig'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryOptionsConfigStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryOptionsConfigStore",
			variables: false,
		})
	}
}

export async function load_InventoryOptionsConfig(params) {
  await initClient()

	const store = new InventoryOptionsConfigStore()

	await store.fetch(params)

	return {
		InventoryOptionsConfig: store,
	}
}
